/* ──────────────────────────────────────────
   Pro Ase Sports — assets/theme.js
   Runs on every page.
   Cart element IDs match sections/header.liquid:
     #cartBody, #cartFooter, #cartCount,
     #cartDrawerCount, #cartSubtotal
────────────────────────────────────────── */

// ── 1. Header height → CSS variable ──────────
// function setHeaderHeight() {
//   // Header section id in header.liquid is "siteNav" (the sticky nav).
//   // The full header wrapper (announce bar + nav) is the parent of siteNav.
//   const nav = document.getElementById('siteNav');
//   if (!nav) return;
//   const headerEl = nav.closest('header') || nav.parentElement || nav;
//   const height   = headerEl.offsetHeight || nav.offsetHeight;
//   document.documentElement.style.setProperty('--header-height', height + 'px');
//   const main = document.getElementById('MainContent');
//   if (main) main.style.paddingTop = height + 'px';
// }
// setHeaderHeight();
// window.addEventListener('resize', setHeaderHeight, { passive: true });


// ── 2-7. Cart ─────────────────────────────────
// The cart drawer lives in sections/cart-drawer.liquid and is driven by
// assets/pa-cart.js (window.PACart). Nav elevation, menu and search are
// handled in sections/header.liquid. Kept here: thin wrappers so older
// inline handlers keep working.

function formatMoney(cents) {
  if (window.PA && typeof window.PA.formatMoney === 'function') return window.PA.formatMoney(cents);
  return '₹' + (cents / 100).toLocaleString('en-IN');
}

function addToCart(variantId, qty) {
  if (window.PACart) return window.PACart.add([{ id: parseInt(variantId, 10), quantity: qty || 1 }], { open: true });
}

function updateCartItemByKey(key, qty) {
  if (window.PACart) return window.PACart.change(key, qty);
}

// [data-open-search] buttons outside the header
document.querySelectorAll('[data-open-search]').forEach(btn => {
  btn.addEventListener('click', () => {
    if (typeof window.openSearch === 'function') window.openSearch();
  });
});


// ── 8. Toast ──────────────────────────────────
function showToast(msg) {
  const t = document.getElementById('paToast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._toastTimer);
  t._toastTimer = setTimeout(() => t.classList.remove('show'), 2800);
}


// ── 9. Wishlist (localStorage) ────────────────
function toggleWishlist(btn, productId, productTitle) {
  const STORAGE_KEY = 'pa_wishlist';
  let list = [];
  try { list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) {}
  const idx = list.indexOf(String(productId));
  if (idx === -1) {
    list.push(String(productId));
    btn.classList.add('liked');
    showToast('♡ Added to Wishlist — ' + productTitle);
  } else {
    list.splice(idx, 1);
    btn.classList.remove('liked');
    showToast('Removed from Wishlist');
  }
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e) {}
  const path = btn.querySelector('path');
  if (path) path.setAttribute('fill', btn.classList.contains('liked') ? '#da362c' : 'none');
}

// Restore wishlist on load
(function restoreWishlist() {
  let list = [];
  try { list = JSON.parse(localStorage.getItem('pa_wishlist') || '[]'); } catch(e) {}
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    const id = btn.getAttribute('data-product-id');
    if (list.includes(String(id))) {
      btn.classList.add('liked');
      const path = btn.querySelector('path');
      if (path) path.setAttribute('fill', '#da362c');
    }
  });
})();


// ── 10. Scroll reveal ─────────────────────────
const revObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('visible');
      revObs.unobserve(e.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.reveal, .reveal-l, .reveal-r').forEach(el => revObs.observe(el));


// ── 11. Live search results ───────────────────
(function initLiveSearch() {
  const searchInput = document.getElementById('searchInput');
  if (!searchInput) return;
  let searchTimer;
  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => {
      const q = searchInput.value.trim();
      if (q.length < 2) {
        const res = document.getElementById('searchResults');
        if (res) { res.classList.remove('has-results'); res.innerHTML = ''; }
        return;
      }
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`)
        .then(r => r.json())
        .then(data => renderSearchResults(data))
        .catch(() => {});
    }, 300);
  });
})();

function renderSearchResults(data) {
  const res = document.getElementById('searchResults');
  if (!res) return;
  const products = data?.resources?.results?.products || [];
  if (products.length === 0) { res.classList.remove('has-results'); res.innerHTML = ''; return; }
  res.classList.add('has-results');
  res.innerHTML = products.map(p => `
    <a href="${p.url}" class="search-result-item" onclick="if(typeof closeSearch==='function')closeSearch()">
      <div class="search-result-img">
        ${p.featured_image
          ? `<img src="${p.featured_image.url}${p.featured_image.url.indexOf('?') > -1 ? '&' : '?'}width=104" alt="" width="52" height="52" loading="lazy"/>`
          : ''}
      </div>
      <div>
        <div class="search-result-name">${p.title}</div>
        <div class="search-result-sport">${p.product_type || ''}</div>
      </div>
      <div class="search-result-price">${p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : ''}</div>
    </a>`).join('');
}


// ── 13. Reel / video interactions ─────────────
document.querySelectorAll('.reel-card').forEach(card => {
  const vid = card.querySelector('video');
  if (!vid) return;
  card.addEventListener('mouseenter', () => vid.play().catch(() => {}));
  card.addEventListener('mouseleave', () => vid.pause());
});

function toggleReel(id, btn) {
  const v = document.getElementById(id);
  if (!v) return;
  if (v.paused) {
    v.play().catch(() => {});
    btn.innerHTML = '<svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>';
  } else {
    v.pause();
    btn.innerHTML = '<svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
  }
}

function toggleMute(vidId, btnId) {
  const v = document.getElementById(vidId);
  const b = document.getElementById(btnId);
  if (!v || !b) return;
  v.muted = !v.muted;
  b.innerHTML = v.muted
    ? '<svg width="10" height="10" fill="currentColor" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" stroke-width="2"/><line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" stroke-width="2"/></svg>'
    : '<svg width="10" height="10" fill="currentColor" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07M19.07 4.93a10 10 0 0 1 0 14.14" stroke="currentColor" stroke-width="2" fill="none"/></svg>';
}


// ── 14. Newsletter form ───────────────────────
document.querySelectorAll('[data-newsletter-form]').forEach(form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const input = form.querySelector('input[type="email"]');
    if (input && input.value.trim()) {
      showToast('✓ Subscribed! Welcome to Pro Ase Sports.');
      input.value = '';
    }
  });
});
